export default __webpack_public_path__ + "static/cellfina-3-b3f13bcd6f363e7572933ee380d6a6cd.jpg";